import layoutComponents from "../../web-sh/src/components/layout";
import DropdownMenu from "./DropdownMenu";

layoutComponents.DropdownMenu = DropdownMenu;

export default layoutComponents;